export const APP_NAME = "Werkio";
export const APP_TAGLINE = "Site time, equipment, and payroll made simple.";
export const APP_SLOGAN = "Track the crew. Count the machines. Close payroll.";
export const APP_HERO =
  "Werkio helps construction managers log daily labor and equipment, apply complex pay rules, approve pay periods, and export payroll-ready records.";
export const APP_DESCRIPTION =
  "Site time, equipment, and payroll made simple for construction teams.";
export const APP_DOMAIN = "werkio.site";
export const APP_URL = "https://app.werkio.site";
export const DOCS_URL = "https://docs.werkio.site";
export const SUPPORT_EMAIL = "hello@werkio.site";

export const API_PREFIX = "/api";

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 200;
export const DAILY_ENTRY_MAX_PAGE_SIZE = 250;

/** Overtime threshold in hours (placeholder — business logic TBD) */
export const DEFAULT_OVERTIME_THRESHOLD_HOURS = 8;

export const EXPORT_MIME_TYPES = {
  csv: "text/csv; charset=utf-8",
  pdf: "application/pdf",
} as const;

/** Cloudflare queue names (infra — match wrangler.toml bindings) */
export const QUEUE_NAMES = {
  exports: "werkio-exports",
  recalc: "werkio-recalc",
  notifications: "werkio-notifications",
} as const;

export const R2_BUCKETS = {
  exports: "werkio-exports",
} as const;

export const CRON_SCHEDULES = {
  /** Monday 08:00 UTC — pay period reminder placeholder */
  payPeriodReminder: "0 8 * * 1",
} as const;

export const FEATURE_FLAGS = {
  onchainProofs: "ENABLE_ONCHAIN_PROOFS",
} as const;

export const ENV_KEYS = {
  appEnv: "APP_ENV",
  appUrl: "APP_URL",
  defaultTimezone: "DEFAULT_TIMEZONE",
  companySecretPepper: "COMPANY_SECRET_PEPPER",
  privyAppId: "PRIVY_APP_ID",
  privyAppSecret: "PRIVY_APP_SECRET",
} as const;
